// extracted by mini-css-extract-plugin
export default {"container":"app_container__XBPJS","container__chat":"app_container__chat__OoMy-"};